import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { mediaCardImageCreationAction } from 'src/reducers/media-image/action'
import { userLimitsUpdateCredits } from 'src/reducers/user-limits/action'
import { selectCurrentCredits } from 'src/reducers/user-limits/selector'
import { Icon } from '@iconify/react'

import { Link as RouterLink } from 'react-router-dom'
import URL from 'src/api/url'
import Lottie from 'react-lottie'

import {
  withStyles,
  Box,
  Typography,
  Card,
  CircularProgress,
} from '@material-ui/core'
import styles from './style'

import { createPromptFromCardAction } from 'src/reducers/course/action'

import { track } from '@amplitude/analytics-browser'

import { startConnection } from 'src/utils/signalR-connection/signalR-connection'
import { addCourseCreationMessageReceivedListener } from 'src/utils/signalR-connection/signalR-connection'
import { CoreButton, CoreTextField } from 'src/components/core'
import ImageLoading from 'src/lotties/mcg-ai-loader.json'
import { messageBoxHideAction } from 'src/reducers/message-box/action'

const AiImage = props => {
  const {
    cardEntity,
    onPhotoClick,
    setAiCount,
    count,
    limit,
    loading,
    handleLoading,
    popupType,
    classes,
  } = props

  const dispatch = useDispatch()
  const currentCredits = useSelector(selectCurrentCredits)

  const [description, setDescription] = useState()
  const [imageUrlForSaveImage, setImageUrlForSaveImage] = useState()
  const [imageURL, setImageURL] = useState()
  const [emptyError, setEmptyError] = useState(false)
  const [isCreationMode, setIsCreationMode] = useState(true)
  const [selectedInspiration, setSelectedInspiration] = useState(0)
  const [isAnimating, setIsAnimating] = useState(false)

  const inspirations = [
    'Astronaut exploring a red canyon on Mars, retro sci-fi poster style',
    'Watercolor painting of a misty pine forest at dawn',
    'Cyberpunk street market at night, neon signs and rain reflections',
    'Surreal dreamscape with melting clocks and floating fish, Dali-inspired',
    'Futuristic train speeding through a glowing jungle, cinematic lighting',
    'Abandoned temple in a desert, covered with ancient symbols',
    'Ocean waves turning into clouds, surreal oil painting',
    'Vaporwave-inspired poolside scene, 90s retro aesthetics',
    'A girl reading a book inside a glass bubble floating over a city',
    'Charcoal sketch of a giant tree growing through a ruined building',
    'Flying whale over a mountain village, whimsical fantasy style',
    'Steampunk airship battle in the sky, dramatic sunset backdrop',
    'Foggy forest with glowing mushrooms, magical atmosphere',
    'Alien marketplace on a purple planet, bold color palette',
    'Minimalist ink drawing of a samurai walking into a storm',
  ]

  useEffect(() => {
    if (popupType == 'create prompt') {
      createPrompt()
    }
  }, [popupType])
  const mobileLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: ImageLoading,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }
  // Rotate inspirations every 3 seconds with animation
  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true)

      // Wait for fade out animation to complete, then change inspiration
      setTimeout(() => {
        setSelectedInspiration(
          prevIndex => (prevIndex + 1) % inspirations.length,
        )
        setIsAnimating(false)
      }, 700) // Half of the transition time
    }, 3000)

    return () => clearInterval(interval)
  }, [inspirations.length])

  const handleSocketMessage = data => {
    addCourseCreationMessageReceivedListener(async message => {
      if (window.CONSTANTS.ID == message[0]) {
        setImageUrlForSaveImage(message[1])
        setImageURL(`${URL.STORAGE}` + message[1])
        setAiCount(count + 10)
        handleLoading(false)
        setIsCreationMode(false) // Switch to result mode
      }
    })
  }

  const sendAiRequest = () => {
    const prompt = description || ''
    if (prompt.trim().length == 0) {
      setEmptyError(true)
      return
    }

    // Deduct 10 credits for image generation (gpt-image-2.5, premium model)
    dispatch(userLimitsUpdateCredits(10))

    handleLoading(true)
    startConnection()
    track('generate_ai_image')
    dispatch(
      mediaCardImageCreationAction(prompt, null, response => {
        handleSocketMessage(response.data)
      }),
    )
  }

  const handleDescription = value => {
    setDescription(value)
  }

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      if (e.shiftKey) {
        // Shift + Enter: Add new line (default behavior)
        return
      } else {
        // Enter: Start generation
        e.preventDefault()
        if (!loading && count < limit && description?.trim()) {
          sendAiRequest()
        }
      }
    }
  }

  const createPrompt = () => {
    var starterText = cardEntity.text.replace(/(<([^>]+)>)/gi, '')

    // Deduct 1 credit for prompt generation
    dispatch(userLimitsUpdateCredits(1))

    track('generate_ai_image_prompt')
    dispatch(
      createPromptFromCardAction(starterText, response => {
        setDescription(response.data)
        setAiCount(count + 1)
      }),
    )
  }

  const handleRecreate = () => {
    setIsCreationMode(true)
    setImageURL(null)
    setImageUrlForSaveImage(null)
  }

  useEffect(() => {
    if (emptyError == true) {
      setTimeout(() => {
        setEmptyError(false)
      }, 1500)
    }
  }, [emptyError])

  const redirectToPlans = () => {
    dispatch(messageBoxHideAction())
    window.location.href = '/pricing'
  }

  //limit reached
  if (count >= limit) {
    return (
      <div className={classes.container}>
        <div className={classes.imageSection}>
          <div className={classes.limitReachedContainer}>
            <div className={classes.limitReachedDiv}>
              <Typography fontWeight={500} fontSize={20} color="#fff">
                Wow, you've reached the ceiling! 🚀
              </Typography>
              <Typography fontWeight={400} fontSize={16} color="#fff">
                You’ve used up all your AI credits. Upgrade your plan or wait
                for the next refill to keep creating!
              </Typography>
            </div>
          </div>

          <div className={classes.buttonContainer}>
            <CoreButton
              style={{
                width: '50%',
                marginTop: '16px',
              }}
              onClick={redirectToPlans}
            >
              See Plans & Upgrade
            </CoreButton>
          </div>
        </div>
      </div>
    )
  }

  //loading animation
  if (loading) {
    return (
      <div className={classes.container}>
        <div className={classes.imageSection}>
          <div className={classes.loadingContainer}>
            <Lottie options={mobileLottieOptions} width={225} height={120} />
          </div>
          <div className={classes.flexGrowDiv}></div>
          <CoreButton
            color="primary"
            fullWidth
            onClick={() => {
              onPhotoClick(imageUrlForSaveImage)
              track('use_ai_image')
            }}
            disabled={true}
            className={classes.useImageButton}
          >
            Use This Image
          </CoreButton>

          <CoreButton
            variant="outlined"
            fullWidth
            onClick={handleRecreate}
            disabled={true}
          >
            Recreate
          </CoreButton>
        </div>
      </div>
    )
  }

  // Creation Mode
  if (isCreationMode) {
    return (
      <div className={classes.container}>
        <div className={classes.mainSection}>
          <img
            src="/assets/BG.png"
            alt=""
            className={classes.backgroundImage}
          />
          <div className={classes.headerContainer}>
            <img
              src="/assets/ai-icon.svg"
              alt=""
              className={classes.headerIcon}
            />
            <Typography className={classes.headerTitle}>
              Describe it, and we’ll generate it.
            </Typography>
          </div>

          <div className={classes.formContainer}>
            <CoreTextField
              multiline
              rows={4}
              fullWidth={true}
              value={description}
              marginTop={false}
              placeholder={'Describe your image...'}
              onChange={e => handleDescription(e.target.value)}
              onKeyDown={handleKeyDown}
              error={emptyError}
              helperText={emptyError && 'Prompt cannot be empty!'}
              disabled={loading}
            />
            <div className={classes.inspirationRow}>
              <Typography className={classes.inspirationLabel}>
                💡 Inspirations:
              </Typography>{' '}
              <div className={classes.inspirationContainer}>
                <Typography
                  fontWeight={400}
                  color={'#637381'}
                  className={`${classes.inspirationText} ${
                    isAnimating
                      ? classes.inspirationTextFadeOut
                      : classes.inspirationTextFadeIn
                  }`}
                >
                  {inspirations[selectedInspiration]}
                </Typography>
              </div>
            </div>
          </div>
          <div className={classes.buttonContainer}>
            <CoreButton
              onClick={() => sendAiRequest()}
              className={classes.generateButton}
              disabled={count >= limit || loading}
              endIcon={
                <div className={classes.endIconContainer}>
                  <Icon
                    className={classes.coinIcon}
                    icon="mage:coin-a"
                    fontSize={14}
                  />{' '}
                  <Typography className={classes.coinText}>10</Typography>
                </div>
              }
            >
              Generate Image
            </CoreButton>
          </div>
        </div>
      </div>
    )
  }

  // Result Mode
  return (
    <div className={classes.container}>
      <div className={classes.imageSection}>
        {imageURL && (
          <>
            <img
              className={classes.generatedImage}
              src={imageURL}
              alt="Generated"
              onClick={() => {
                onPhotoClick(imageUrlForSaveImage)
                track('use_ai_image')
              }}
            />

            <div className={classes.flexGrowDiv}></div>

            <CoreButton
              color="primary"
              fullWidth
              onClick={() => {
                onPhotoClick(imageUrlForSaveImage)
                track('use_ai_image')
              }}
              disabled={loading}
              className={classes.useImageButton}
            >
              Use This Image
            </CoreButton>

            <CoreButton
              variant="outlined"
              fullWidth
              onClick={handleRecreate}
              disabled={loading}
            >
              Recreate
            </CoreButton>
          </>
        )}
      </div>
    </div>
  )
}

export default withStyles(styles)(AiImage)
